const day = ["Sun", "Mon", "Tues", "Wed", "Thurs", "Fri", "Sat"];
const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function isToday(now, then) {
  return now.toDateString() === then.toDateString();
}
function isTomorrow(now, then) {
  const tomorrow = new Date(now.getTime() + 864e5);
  return tomorrow.toDateString() === then.toDateString();
}
function formatDay(date) {
  return day[date.getDay()];
}
function formatMonth(date) {
  return month[date.getMonth()];
}
function formattedPickUpTimeRounded(date) {
  let minutes = date.getMinutes();
  let roundedDate;
  if (minutes % 5 !== 0) {
    const coeff = 1e3 * 60 * 5;
    roundedDate = new Date(Math.round((date.getTime() + 15e4) / coeff) * coeff);
  } else {
    roundedDate = date;
  }
  const hour = roundedDate.getHours();
  minutes = roundedDate.getMinutes() < 10 ? `0${roundedDate.getMinutes()}` : roundedDate.getMinutes();
  const amPm = hour < 12 ? "am" : "pm";
  const parsedHour = hour <= 12 ? hour : hour - 12;
  const time = `${parsedHour}:${minutes}${amPm}`;
  return time;
}
function numberOfDays(now, then) {
  if (then.getMonth() === now.getMonth()) return then.getDate() - now.getDate();
  let days = 0;
  let i = now.getMonth();
  const isLeap = new Date(then.getFullYear(), 1, 29).getDate() === 29;
  const daysInMonth = [31, isLeap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  while (i !== then.getMonth()) {
    if (now.getMonth() === i) {
      days += daysInMonth[i] - now.getDate();
    } else {
      days += daysInMonth[i];
    }
    if (i < 11) {
      i += 1;
    } else {
      i = 0;
    }
  }
  return days + then.getDate();
}
function daysUntilNow(now, then) {
  if (isToday(now, then)) return 0;
  if (isTomorrow(now, then)) return 1;
  return numberOfDays(now, then);
}
function formatDate(date) {
  return `${formatDay(date)}, ${formatMonth(date)} ${date.getDate()}`;
}
function formattedPickupEadV3(date, timeZone) {
  const now = new Date((/* @__PURE__ */ new Date()).toLocaleString("en-US", { timeZone }));
  if (isToday(now, date)) {
    return `Today after ${formattedPickUpTimeRounded(date)}`;
  }
  if (isTomorrow(now, date)) {
    return `Tomorrow after ${formattedPickUpTimeRounded(date)}`;
  }
  return formatDate(date);
}
function daysAgo(now, then) {
  return (now.getTime() - then.getTime()) / 864e5;
}
function relativeTime(timestamp) {
  const now = /* @__PURE__ */ new Date();
  const then = new Date(timestamp);
  const daysGoneBy = Math.ceil(daysAgo(now, then));
  const timeInWeeks = Math.floor(daysGoneBy / 7);
  const timeInMonths = Math.floor(daysGoneBy / 30.44);
  const timeInYears = Math.floor(daysGoneBy / 365);
  let relativeTimeString = "";
  if (daysGoneBy === 0) relativeTimeString = "Today";
  if (daysGoneBy > 0 && daysGoneBy <= 7) relativeTimeString = `${daysGoneBy} ${daysGoneBy === 1 ? "day" : "days"} ago`;
  if (daysGoneBy > 7 && daysGoneBy <= 30) relativeTimeString = `${timeInWeeks} ${timeInWeeks === 1 ? "week" : "weeks"} ago`;
  if (daysGoneBy > 30 && daysGoneBy <= 365 && timeInMonths < 12 && timeInYears === 0) relativeTimeString = `${timeInMonths} ${timeInMonths === 1 ? "month" : "months"} ago`;
  else if (timeInYears > 0) relativeTimeString = `${timeInYears} ${timeInYears === 1 ? "year" : "years"} ago`;
  return relativeTimeString;
}
export {
  daysUntilNow,
  formatDate,
  formatDay,
  formatMonth,
  formattedPickUpTimeRounded,
  formattedPickupEadV3,
  isToday,
  isTomorrow,
  relativeTime
};
//# sourceMappingURL=dates.mjs.map
